import produce from 'immer'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import assetActions from 'actions/assets'
import { getSharedAssetOptions } from 'helpers/offlineData'
import { wrapItems, filterBySearch } from 'helpers/utils'
import Component from 'components/Orders/AddItems/SelectAsset'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(assetActions.getOptions({ ...params }))
        .catch(async (error) => {
          if (!error.response) {
            const items = await getSharedAssetOptions().then((r) => r.filter(filterBySearch(params.search)))

            return wrapItems(items)
          }

          throw error
        })
        .then((r) =>
          produce(r, (draft) => {
            if (params.pageIndex <= 1 && !params.search) {
              draft.value.data.items.unshift({ id: 0, displayName: '' })
              draft.value.data.recordCount++
            }
          })
        ),
  }),
})(Component)
